export default "__VITE_ASSET__CMpQ1f6Z__"